import { render, staticRenderFns } from "./performance-templates.vue?vue&type=template&id=4468e9f6"
import script from "./performance-templates.vue?vue&type=script&lang=js"
export * from "./performance-templates.vue?vue&type=script&lang=js"
import style0 from "./performance-templates.vue?vue&type=style&index=0&id=4468e9f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports